// extracted by mini-css-extract-plugin
export default {"gradientCanvas":"StripeGradient_gradientCanvas__OqTTG"};